import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type ToggleIcebreakerMutationVariables = Types.Exact<{
  id: Types.Scalars['Int'];
}>;


export type ToggleIcebreakerMutation = { __typename?: 'Mutation', toggleIcebreaker?: { __typename?: 'ToggleIcebreakerPayload', successful?: boolean | null, examQuestionGroup?: { __typename?: 'ExamQuestionGroup', id: number } | null } | null };

export const ToggleIcebreakerDocument = gql`
    mutation ToggleIcebreaker($id: Int!) {
  toggleIcebreaker(id: $id) {
    successful
    examQuestionGroup {
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleIcebreakerGQL extends Apollo.Mutation<ToggleIcebreakerMutation, ToggleIcebreakerMutationVariables> {
    document = ToggleIcebreakerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }